module.exports = __webpack_public_path__ + "assets/img/18_1832.7da73c46.jpg";